import { render } from "./BoxVisual.vue?vue&type=template&id=2d71298d&scoped=true"
import script from "./BoxVisual.vue?vue&type=script&lang=js"
export * from "./BoxVisual.vue?vue&type=script&lang=js"

import "./BoxVisual.vue?vue&type=style&index=0&id=2d71298d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d71298d"]])

export default __exports__